import { styled } from "@mui/material";
import clsx from "clsx";
import { NavBar } from "components/NavBar";

const PREFIX = "UnauthenticatedLayout";

const classes = {
	root: `${PREFIX}-root`,
};

const Root = styled("div")(() => ({
	[`&.${classes.root}`]: {
		textAlign: "center",
		marginTop: "148px",
		padding: "5% 0%",
		marginLeft: "1%",
		marginRight: "1%",
	},
}));

export interface UnauthenticatedLayoutProps {
	children: React.ReactNode;
	className?: string;
}

export const UnauthenticatedLayout = ({
	children,
	className,
}: UnauthenticatedLayoutProps): JSX.Element => (
	<Root className={clsx(classes.root, className)}>
		<NavBar />
		{children}
	</Root>
);
